export enum PAYMENT_TYPES {
  CUSTOMER = 'CUSTOMER',
  AGENT = 'AGENT',
  BROKER = 'BROKER',
}
